export default function setZIndexMenu({zindex}) {
  document.documentElement.style.setProperty('--zIndexMenu', zindex);
}